import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { CustomerPensionProtectionModel } from '../../Models/Domains/Drawdown/CustomerPensionProtectionModel';
import { ServiceValidationError } from '../../Core/DataTypes/ServiceValidation/ServiceValidationError';
import { PensionProtectionDetails } from '../../Models/Models/Customer/PensionProtection/PensionProtectionDetails';

declare var IS_RUNNING_IN_APP_POOL;

export class PensionProtectionInstructionClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(hierarchyid: string): Promise<CustomerPensionProtectionModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Instruction/PensionProtectionInstruction/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyid: hierarchyid }

    return AjaxWrapper.get<CustomerPensionProtectionModel, any>(url, data);
  }
  public put(hierarchyid: string, details: PensionProtectionDetails): Promise<Array<ServiceValidationError>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Instruction/PensionProtectionInstruction/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyid: hierarchyid, details: details }

    return AjaxWrapper.put<Array<ServiceValidationError>, any>(url, data);
  }
}

